import React from 'react';

import './App.css';

export function Popup ({ isPopUpOpen, setIsPopUpOpen, children }) {
  if (!isPopUpOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="close-button" onClick={() => {
          setIsPopUpOpen(false)
        }}>
          X
        </button>
          { children }
      </div>
    </div>
  );
};